import {TIMEZONES} from './constants'

export default function populateTimezones() {
  // On document ready
  document.addEventListener('DOMContentLoaded', () => {
    const timezoneSelect = document.getElementById('mg-timezone-selector')

    if (!timezoneSelect) {
      return
    }

    // Populate the timezone select dropdown
    TIMEZONES.forEach((timezone) => {
      const option = document.createElement('option')
      option.value = timezone
      option.text = timezone
      timezoneSelect.appendChild(option)
    })
  })
}
